import type { BatchProcessDto } from "@fp/admin-api-client";
import { ChevronDown, ChevronUp } from "@untitledui/icons";
import { BatchProcessItemList } from "./batch-process-item-list";
import { BatchProcessSummary } from "./batch-process-summary";
import { useBatchProcessRun } from "./use-batch-process-run";

export interface BatchProcessCardProps {
  batch: BatchProcessDto;
  isExpanded: boolean;
  onToggleExpand: () => void;
}

export function BatchProcessCard({
  batch,
  isExpanded,
  onToggleExpand,
}: BatchProcessCardProps) {
  const run = useBatchProcessRun(batch, isExpanded);
  const ChevronIcon = isExpanded ? ChevronUp : ChevronDown;

  return (
    <div className="relative overflow-hidden rounded-lg border border-secondary bg-primary">
      <button
        type="button"
        onClick={onToggleExpand}
        aria-label={isExpanded ? "Collapse items" : "Expand items"}
        aria-expanded={isExpanded}
        className="block w-full cursor-pointer p-3 text-left hover:bg-primary_hover"
      >
        <ChevronIcon className="absolute right-3 top-3 size-4 text-fg-quaternary" />
        <BatchProcessSummary batch={run.batch ?? batch} />
      </button>

      {isExpanded && <BatchProcessItemList run={run} />}
    </div>
  );
}
